export enum PaletaColoresEnum{
    /** COLORES ROJOS */
    IndianRed = '#CD5C5C',
    LightCoral = '#F08080',
    Salmon = '#FA8072',
    Red = '#FF0000',
    DarkRed = '#8B0000',

    /** COLORES NARANJA */
    OrangeRed = '#FF4500',
    DarkOrange = '#FF8C00',
    Orange = '#FFA500',

    /** COLORES AMARILLOS */
    Gold = '#FFD700',

    /** COLORES PÚRPURA */
    Violet = '#EE82EE',
    DarkMagenta = '#8B008B',
    DarkViolet = '#9400D3',
    Indigo = '#4B0082'

}

export class PaletaColores {
    public static obtenerEnum(valor: string): PaletaColoresEnum {
        switch (valor) {
            case 'IndianRed': return PaletaColoresEnum.IndianRed;
            case 'LightCoral': return PaletaColoresEnum.LightCoral;
            case 'Salmon': return PaletaColoresEnum.Salmon;
            case 'Red': return PaletaColoresEnum.Red;
            case 'DarkRed': return PaletaColoresEnum.DarkRed;
            case 'OrangeRed': return PaletaColoresEnum.OrangeRed;
            case 'DarkOrange': return PaletaColoresEnum.DarkOrange;
            case 'Orange': return PaletaColoresEnum.Orange;
            case 'Gold': return PaletaColoresEnum.Gold;
            case 'Violet': return PaletaColoresEnum.Violet;
            case 'DarkMagenta': return PaletaColoresEnum.DarkMagenta;
            case 'DarkViolet': return PaletaColoresEnum.DarkViolet;
            case 'Indigo': return PaletaColoresEnum.Indigo;
        }
        return null;
    }



    public static obtenerNombreColor(codigo: string): String{
        switch (codigo) {
            case '#CD5C5C': return 'IndianRed';
            case '#F08080': return 'LightCoral';
            case '#FA8072': return 'Salmon';
            case '#FF0000': return 'Red';
            case '#8B0000': return 'DarkRed';
            case '#FF4500': return 'OrangeRed';
            case '#FF8C00': return 'DarkOrange';
            case '#FFA500': return 'Orange';
            case '#FFD700': return 'Gold';
            case '#EE82EE': return 'Violet';
            case '#8B008B': return 'DarkMagenta';
            case '#9400D3': return 'DarkViolet';
            case '#4B0082': return 'Indigo';
           
        }
        return null;
    }
}